import { IFieldConfiguration } from '@/components/atoms/form/entities/field-configuration.interface';
import { IValidationErrors } from '@/components/atoms/form/validation/validation-errors.interface';
import { IValidator } from '@/components/atoms/form/validation/validator.interface';
import { Prop, Vue, Component } from 'vue-facing-decorator';

@Component
export class InputValidator extends Vue {
    @Prop({ required: true })
    public config!: IFieldConfiguration<string>;

    protected baseValidators: IValidator<string>[] = [];

    /**
     * whatItDoes
     * validates input value against list of provided validator functions
     */
    protected validateInput(value: string): IValidationErrors | null {
        let validators: IValidator<string>[];

        if (this.config.validators !== undefined) {
            validators = this.baseValidators.concat(this.config.validators);
        } else {
            validators = this.baseValidators;
        }

        if (validators.length === 0) {
            return null;
        }

        return validators.reduce((validationState: IValidationErrors | null, validator: IValidator<string>) => {
            if (validationState === null) {
                return validator.fn(value, validator.name, validator.message);
            }

            const validation = validator.fn(value, validator.name, validator.message);

            return validation === null ? validationState : { ...validationState, ...validation };
        }, null);
    }
}
